import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import {
  URL_TRAINING_DOCUMENTATION,
  URL_TRAINING_PILLS,
  URL_TRAINING_TIPS,
} from '@app/@core/constants/routes.constants';
import { UserType } from '@app/@core/constants/user-credentials.constants';
import { CredentialsService, AuthenticationService } from '@app/login';

@Injectable({
  providedIn: 'root',
})
export class TrainingGuard implements CanActivate {
  constructor(private router: Router, private credentialsService: CredentialsService) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    console.log(state.url);
    if (this.credentialsService.isAuthenticated()) {
      if (state.url === URL_TRAINING_DOCUMENTATION && !this.isAdminServiceMarketing()) {
        return true;
      } else if (state.url === URL_TRAINING_PILLS && !this.isAdminServiceMarketing()) {
        return true;
      } else if (state.url === URL_TRAINING_TIPS && !this.isAdminServiceMarketing()) {
        return true;
      } else {
        this.router.navigate(['/**'], { replaceUrl: true });
        return false;
      }
    } else {
      return false;
    }
  }

  private isAdminServiceMarketing() {
    return (
      this.credentialsService.credentials.userType === UserType.ADMIN ||
      this.credentialsService.credentials.userType === UserType.CENTER_SERVICE ||
      this.credentialsService.credentials.userType === UserType.MARKETING_DIRECT
    );
  }
}
